import { Anchor, Box, Button, Text } from '@usap/uicomponents'
import styled from 'styled-components'

const darkSecondary = props => props.theme.global.colors["darkSecondary"];
const dark5 = props => props.theme.global.colors["dark-5"];
const white = props => props.theme.global.colors["white"];
const fontSize2 = props => props.theme.heading.level[2].small["size"];
const fontSize3 = props => props.theme.heading.level[3].small["size"];
const fontSize5 = props => props.theme.heading.level[5].small["size"];
const fontSize6 = props => props.theme.heading.level[6].small["size"];
const borderColor = props => props.theme.global.colors["light-3"];
const tabletBreakpoints = props => props.theme.mediaQuery.up('tablet-landscape');

export const GrommetContainer = styled(Box)`
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  padding: 24px 0px;

  ${tabletBreakpoints} {
    padding: 24px 40px;
  }

`
export const TrackContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-bottom: 16px;

  ${tabletBreakpoints} {
    flex-direction: row;
    gap: 24px;
    padding-bottom: 24px;
  }
`;

export const LeftContainer = styled(Box)`
  ${tabletBreakpoints} {
    flex-grow: 1;
  }
`
export const TrackCard = styled(Box)`
  padding: 16px;
  margin: 0 16px 16px;
  background: ${white};
  border: 1px solid #D4D4D6;
  height: fit-content;

  ${tabletBreakpoints} {
    flex-grow: 1;
    padding: 24px;
    margin: 0 0 16px;
  }
`
export const ShippingCard = styled(Box)`
  margin: 0 16px;
  flex-grow: 1;

  ${tabletBreakpoints} {
  margin: 0px;
  width: 100%;
  max-width: 448px;
  }
`

export const MainContainer = styled(Box)`
  display: flex;
  flex-direction: column;
`

export const ChatCardContainer = styled(Box)`
  display: ${props => props.showOnMobile ? 'block' : 'none'};
  margin: 0 16px -16px;

 ${tabletBreakpoints} {
  margin: 0;
  width: auto;
  max-width: 448px;
  display: ${props => props.showOnMobile ? 'none' : 'block'};
 }
`

export const TitleText = styled(Text)`
  font-size: ${fontSize3};
  font-weight: 500;
  line-height: 36px;
  color: ${dark5};

  ${tabletBreakpoints} {
    font-size:${fontSize2}; 
  }
`
export const SubHeading = styled(Text)`
  font-size:${fontSize6};
  font-weight: 400;
  margin-bottom:16px;
  color: ${darkSecondary};
  line-height: 20px; 
  letter-spacing: 0.25px;
`
export const FieldHeader = styled.div`
  font-size: ${fontSize6};
  font-weight: 400;
  margin-bottom: 14px;
  color: ${darkSecondary};
  line-height: 20px;
  letter-spacing: 0.25px;
`;
export const SubmitButton = styled(Button)`
 height: 100%;
 font-size: ${fontSize6};
 height:100%;
 background-color:${darkSecondary};
 border:1px solid #282832;
 padding:12px 24px;
 border-radius:4px;
 font-weight:700;
 line-height:24px;
 letter-spacing:0.5px;

  ${tabletBreakpoints} {
    font-size:${fontSize5}; 
  }
`
export const LinkText = styled(Anchor)`
  color: #05629B;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 19.8px;
  text-decoration-line: underline;
  cursor: pointer;
  display: inline;
`
export const TipContainer = styled.div`
  display: flex;
  padding: 0px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`
export const TipText = styled(Text)`
  color: #3E3E47;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 19.8px;
`

export const ContactUsWrapper = styled.div`
  background-color: ${white};
  border-radius: 4px;
  border: 1px solid ${borderColor};
  padding: 16px;
  margin: 0 16px 0; 
  display: ${props => props.showOnMobile ? 'block' : 'none'};

  ${tabletBreakpoints} {
    font-size:${fontSize5}; 
    margin: 0;
      display: ${props => props.showOnMobile ? 'none' : 'block'};
  }
`

export const MobileDisplayOnly = styled.div`
  background: #fff;
  overflow: hidden;

  ${tabletBreakpoints} {
    display: none;  
  }
`

export const DesktopDisplayOnly = styled.div`
  display: none;  
  background: #fff;
  padding-bottom: 24px;
  
  ${tabletBreakpoints} {
    display: block; 
    padding: 0 12px 56px
  }
`

export const UptickWrapper = styled.div`
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid #D4D4D6;
    margin:  ${props => props.isMobile ? '0 16px 0 16px' : '0 0 16px 0'};
    
    &:not(:empty) {
        min-height: 150px;  
        ${props => props.theme.mediaQuery.down('mobile-landscape')} {
            min-height: 257px;  
        }
    }

    &:empty, &:has(> .uptick-flow-complete) {
        border: none;
        margin: 0;
        display: none;
    }
        
    & .uptick.uptick-inline {
        margin-top: 0;
    }
`